import { createConfig, http } from 'wagmi';
import {
  mainnet,
  bsc,
  polygon,
  arbitrum,
  optimism,
  base,
  avalanche,
  sepolia,
} from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

const walletConnectProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID?.trim();
const hasValidWalletConnectProjectId = Boolean(walletConnectProjectId && walletConnectProjectId.length >= 20);

export const EVM_CHAINS = [mainnet, bsc, polygon, arbitrum, optimism, base, avalanche] as const;

// Map our network names to chain IDs
export const NETWORK_TO_CHAIN_ID: Record<string, number> = {
  'Ethereum (ERC20)': mainnet.id,
  'BSC (BEP20)': bsc.id,
  Polygon: polygon.id,
  Arbitrum: arbitrum.id,
  Optimism: optimism.id,
  Base: base.id,
  'Avalanche C-Chain': avalanche.id,
};

export const CHAIN_ID_TO_NETWORK: Record<number, string> = Object.fromEntries(
  Object.entries(NETWORK_TO_CHAIN_ID).map(([k, v]) => [v, k])
);

export const isEVMNetwork = (networkName: string): boolean => networkName in NETWORK_TO_CHAIN_ID;

const evmConnectors = hasValidWalletConnectProjectId && walletConnectProjectId
  ? [
      injected(),
      walletConnect({
        projectId: walletConnectProjectId,
        showQrModal: true,
      }),
    ]
  : [injected()];

export const wagmiConfig = createConfig({
  chains: [mainnet, bsc, polygon, arbitrum, optimism, base, avalanche, sepolia],
  connectors: evmConnectors,
  transports: {
    [mainnet.id]: http(),
    [bsc.id]: http(),
    [polygon.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
    [base.id]: http(),
    [avalanche.id]: http(),
    [sepolia.id]: http(),
  },
});
